/**
 * Extracts the engagement ID (engi-XXXXXXXXXX) from a cloud provider ID string
 * Example input: "arn:aws:partnercentral:us-east-1::catalog/Sandbox/engagement-invitation/engi-d64atmm1dfkla"
 * Example output: "engi-d64atmm1dfkla"
 */
export const extractEngagementId = (cloudProviderId: string): string => {
  if (!cloudProviderId) {
    return '';
  }

  const parts = cloudProviderId.split('/');
  return parts[parts.length - 1];
};
